module.exports = __webpack_public_path__ + "img/U4.a780a8fc.png";